import Carousel from '@/common/Carousel/Carousel';
import { useIsMobile } from '~/context/common/DeviceContext';
import { PillOptions } from '~/contracts/sem/SemLandingPageContent';
import useCarouselSettings from '~/hooks/sem/useCarouselSettings';
import { BodyStyleLabel, BodyStyleWrapper } from './Hero.styles';

function BodyStyleCarousel({ bodystyles }: { bodystyles: PillOptions }) {
  const isMobile = useIsMobile();
  const { values, carouselRef } = useCarouselSettings({
    sectionName: 'Bodystyles',
    useDesktopDefaultSettings: false,
    maxLength: bodystyles?.length,
    widthGap: isMobile ? 128 : 214
  });

  return (
    <Carousel {...values} ref={carouselRef}>
      {bodystyles.map(bodystyle =>
        bodystyle.slug ? (
          <a
            href={bodystyle.slug}
            key={bodystyle.title}
            className="inline-block !w-fit no-underline"
            data-analytics-id="Hero - BodyStyle Pill"
            data-analytics-attributes={JSON.stringify({
              title: bodystyle.title,
              linkUrl: bodystyle.slug
            })}
          >
            <BodyStyleWrapper>
              {bodystyle.imageSrc && (
                <picture className="w-full, h-full">
                  <source
                    media="(min-width: 1024px)"
                    srcSet={bodystyle.imageSrc}
                  />
                  <source
                    media="(min-width: 768px)"
                    srcSet={bodystyle.imageSrc}
                  />
                  <img src={bodystyle.imageSrc} alt={bodystyle.title ?? ''} />
                </picture>
              )}
              <BodyStyleLabel>{bodystyle.title}</BodyStyleLabel>
            </BodyStyleWrapper>
          </a>
        ) : null
      )}
    </Carousel>
  );
}

export default BodyStyleCarousel;
